import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'mibi-default-page-layout',
    templateUrl: './default-page-layout.component.html',
    styleUrls: ['./default-page-layout.component.scss']
})
export class DefaultPageLayoutComponent {

}
